'use strict';

const CONST = require('plugin_frontend_core/constants');
const base = require('app_storefront_base/product/base');
const productImages = require('./product-images');
const photoswipe = require('./photoswipe');
const scrollTo = require('plugin_frontend_components/components/scroll-to');

require('plugin_catalog/product/badge');
require('./components/out-of-stock.js').init();
require('./components/store-availability.js').init();

const selectors = {
    productID: '.product-id',
    productBrand: '.js-product-brand',
    productDetail: '.product-detail',
    productDetailTopBlock: '.js-product-detail-top-block',
    productPrimaryImages: '.js-primary-images',
    productDetailNotBundle: '.product-detail:not(".bundle-item")',
    productBundleItems: '.product-detail > .bundle-items',
    productCarouselMain: '.js-product-images-main',
    productCarouselThumbs: '.js-product-images-thumbs',
    productVariations: '.product-detail__variations',
    pdpColorLinks: '.product-variation--color .variant__link',
    pdpSizeLinks: '.product-detail-variants__size .variant__link',
    pdpSizeDropdown: '.product-detail-variants__size.variant-select',
    selectOption: 'option',
    selectedOption: ':selected',
    selectVariations: '.please-select-variations',
    variantLink: '.variant__link',
    sizechartLink: '.js-size-chart-link',
    modalBody: '.js-modal-body',
    longDescription: '.js-longdescription',
    shortDescription: '.js-shortdescription',
    productDetailVariations: '.js-product-detail-variations',
    productAttribute: '.js-product-attributes',
    productSetDetail: '.product-set-detail',
    productDetailImageLink: '.js-product-detail-image-link',
    addToCartStickyBar: '.js-product-detail__sticky-bar',
    pdpMicroTextSlot: '.js-pdp-micro-text-slot',
    chatIcon: '.embeddedServiceHelpButton .helpButton',
    addCart: '.js-add-to-cart',
    addCartGlobal: '.js-add-to-cart-global',
    addToWishlist: '.js-add-to-wishlist',
    attributeLabel: '.js-attribute-label',
    detailBodyShow: '.js-details-body.show',
    detailsHeading: '.js-details-heading',
    availability: 'div.availability',
    availabilityMessage: '.availability-msg',
    availabilityGlobal: '.global-availability',
    shippingMessage: '.js-shipping-message',
    extraDiscountBadge: '.js-badge-promotion'
};

const classes = {
    selectedVariant: 'selected',
    unselectableVariant: 'unselectable disabled'
};

/**
* Initializes all size-variations functionality
*/
function initSizeVariations() {
    bindEventListeners();
}

/**
* Binds event listeners
*/
function bindEventListeners() {
    const $doc = $(document);

    $doc.on(CONST.events.productAfterAttrValuesUpdate, updateSizeLinks);
    $doc.on(CONST.events.click, selectors.pdpSizeLinks, handleSizeLink);
    $doc.on(CONST.events.change, selectors.pdpSizeDropdown, handleSizeDropdown);
}

/**
* Updates the size links after the size dropdown is updated
*/
function updateSizeLinks() {
    $(selectors.pdpSizeDropdown).find(selectors.selectOption).each(function (i) {
        var $option = $(this);
        var $equivalentSizeLink = $(selectors.pdpSizeLinks).eq(i - 1);
        var isDisabled = $option.attr(CONST.attributes.disabled);

        if (isDisabled) {
            $equivalentSizeLink.addClass(classes.unselectableVariant);
        } else {
            $equivalentSizeLink.removeClass(classes.unselectableVariant);
        }
    });
}

/**
* Handler for 'links' version of size selection
* @param {jQuery.event} e - Event
*/
function handleSizeLink(e) {
    // Return if variant is unselectable
    if (e.currentTarget.classList.contains('unselectable')) {
        return;
    }

    var $link = $(e.target).closest(selectors.variantLink);
    var value = $link.attr(CONST.attributes.attrValue);

    // Update the classes of each variant
    $link.closest(selectors.variantLink).toggleClass(classes.selectedVariant);
    $link.closest(selectors.variantLink).siblings().removeClass(classes.selectedVariant);

    // Stop if the event is not triggered by the user, to prevent an infinite loop
    if (!e.originalEvent) {
        return;
    }

    // Sync all size link/dropdown selectors
    syncAllSizeSelectors(value);
}

/**
* Handler for 'dropdown' version of size selection
* @param {jQuery.event} e - Event
*/
function handleSizeDropdown(e) {
    var $dropdown = $(e.target);
    var value = $dropdown.find(selectors.selectedOption).attr(CONST.attributes.attrValue);

    // Stop if the event is not triggered by the user, to prevent an infinite loop
    if (!e.originalEvent) {
        return;
    }

    // Sync all size link/dropdown selectors
    syncAllSizeSelectors(value);
}

/**
* Is called when either the 'links' or 'dropdown' version of size selection is used.
* Makes sure to update the other version is updated to keep them in sync.
* @param {string} value - The variation value
*/
function syncAllSizeSelectors(value) {
    // Update the links with the same value as the dropdown
    $(selectors.pdpSizeLinks).each(function (i, sizeLink) {
        $(sizeLink).find('[' + CONST.attributes.attrValue + '="' + value + '"]').eq(0).trigger(CONST.events.click);
    });

    // Update the dropdown with the same value as the links
    var $optionTarget = $(selectors.pdpSizeDropdown).find('[' + CONST.attributes.attrValue + '="' + value + '"]').eq(0);
    var optionValue = $optionTarget.val();

    $(selectors.pdpSizeDropdown).each(function (i) {
        var $dropdown = $(this);
        $dropdown.val(optionValue);

        // Only trigger change event for the first dropdown to prevent multiple ajax calls.
        // JVP @TODO: If the change event is triggered on the first dropdown is it possible that a race condition is created and the change fires before this is done?
        if (i === 0) {
            $dropdown.trigger(CONST.events.change);
        }
    });
}

/**
 * Adjusting chat icon position since there can be micro text just under the add to cart button on mobile device.
 */
function adjustChatIconPosition() {
    setTimeout(function () {
        const $pdpMicroTextSlot = $(selectors.pdpMicroTextSlot);

        if (!$pdpMicroTextSlot.length || window.innerWidth >= CONST.breakpoints.md) {
            return;
        }

        const $addToCartStickyBar = $(selectors.addToCartStickyBar);
        const $chatIcon = $(selectors.chatIcon);
        const chatIconMarginBottomValue = $addToCartStickyBar.height() + 20;
        $chatIcon.css('margin-bottom', chatIconMarginBottomValue);
    }, 5000);
}

module.exports = {
    scrollTo: scrollTo.init(),
    availability: base.availability,
    addToCart: base.addToCart,
    onAddToCartClick: base.onAddToCartClick,
    initSizeVariations: initSizeVariations,
    productImages: productImages.init,
    photoswipe: photoswipe.init,

    updateAttributesAndDetails() {
        $(CONST.selectors.body).on(CONST.events.productStatusUpdate, function (e, data) {
            var $productContainer = $(selectors.productDetail);

            var activeDetailsHeading = $(`${selectors.detailsHeading}:not(${CONST.classes.collapsed})`).attr(CONST.attributes.id);
            var activeDetailsBody = $(selectors.detailBodyShow).attr(CONST.attributes.id);

            if (data.attributesHtml) {
                $productContainer.find(selectors.productAttribute)
                    .empty()
                    .html(data.attributesHtml);

                $('#' + activeDetailsHeading).removeClass(CONST.classes.collapsed);
                $('#' + activeDetailsBody).addClass(CONST.classes.show);
            }

            if (data.brand) {
                $productContainer.find(selectors.productBrand).eq(0)
                    .empty()
                    .html(data.brand);
            }

            if (data.shortDescription) {
                $productContainer.find(selectors.shortDescription).eq(0)
                    .empty()
                    .html(data.shortDescription);
            }

            if (data.longDescription) {
                $productContainer.find(selectors.longDescription)
                    .empty()
                    .html(data.longDescription);
            }
        });
    },
    showSpinner() {
        $(CONST.selectors.body).on([CONST.events.beforeAddToCart, CONST.events.productBeforeAttributeSelect].join(' '), function () {
            $.spinner().start();
        });
    },
    updateAttribute() {
        $(CONST.selectors.body).on(CONST.events.productAfterAttributeSelect, function (e, response) {
            const productData = response.data.product;
            const productID = productData.masterID ? productData.masterID : productData.id;

            const $productContainer = $(response.container);
            const $extraDiscountBadge = $(selectors.productDetailTopBlock + ' ' + selectors.extraDiscountBadge);

            const $productAttributes = $productContainer.find(CONST.selectors.product.attributes.container);
            $productAttributes.each(function () {
                const $productAttribute = $(this);
                const hasAttributeItems = $productAttribute.find(CONST.selectors.product.attributes.item).length > 0;
                const hasSelectedAttribute = $productAttribute.find(CONST.selectors.product.attributes.selected).length > 0;
                const $productAttributeMessage = $productAttribute.find(CONST.selectors.product.attributes.message);

                if (hasAttributeItems && hasSelectedAttribute) {
                    $productAttribute.removeClass(CONST.classes.product.attributes.errorState);
                    $productAttributeMessage.addClass(CONST.classes.dNone);
                }
            });

            if (productData.promotions) {
                productData.promotions.forEach(function (promotion) {
                    if (promotion.media) {
                        response.container.find(selectors.productPrimaryImages)
                        .next()
                        .empty()
                        .html("<img src='" + promotion.media + "' />");
                    }
                });
            } else {
                $extraDiscountBadge.html("");
            }

            if ($(selectors.productBundleItems).length) {
                response.container.attr(CONST.attributes.product.productID, productData.id);
                response.container.find(selectors.productID).text(productID);
            } else if ($(selectors.productSetDetail)[0]) {
                response.container.attr(CONST.attributes.product.productID, productData.id);
                response.container.find(selectors.productID).text(productID);
            } else {
                $(selectors.productID)
                    .text(productID)
                    .attr(CONST.attributes.product.productID, productData.id);
                $(selectors.productDetailNotBundle)
                    .attr(CONST.attributes.product.productID, productData.id)
                    .data(CONST.attributes.pid, productData.id);

                // JVP @TODO: Refactor in architechture sprint
                // JVP @TODO: SFRA setup doesn't into account take the fact that some variations can have more/less images
                if ('images' in productData) {
                    var $mainImages = $(selectors.productCarouselMain);
                    var $thumbnails = $(selectors.productCarouselThumbs);

                    Object.keys(productData.images.hires).map(function (i) {
                        var img = productData.images.hires[i];
                        $mainImages.find(selectors.productDetailImageLink).eq(i).attr({
                            href: img.url
                        });
                    });

                    Object.keys(productData.images.large).map(function (i) {
                        var img = productData.images.large[i];
                        $mainImages.find(CONST.selectors.img).eq(i).attr({
                            src: img.url,
                            alt: img.alt
                        });
                    });

                    Object.keys(productData.images.small).map(function (i) {
                        var img = productData.images.small[i];
                        $thumbnails.find(CONST.selectors.img).eq(i).attr({
                            src: img.url,
                            alt: img.alt
                        });
                    });
                }

                // JVP @TODO: Refactor in architechture sprint
                if ('variationAttributes' in productData) {
                    Object.keys(productData.variationAttributes).map(function (i) {
                        var attr = productData.variationAttributes[i];
                        var $variations = $(selectors.productVariations);
                        var $variantContainer = $variations.find('[data-attr="' + attr.id + '"]');
                        var $label = $variantContainer.find(selectors.attributeLabel);
                        var labelTextSelect = $label.data(CONST.attributes.textSelect);
                        var labelTextSelected = $label.data(CONST.attributes.textSelected);

                        if (attr.selectedValue) {
                            $label.text(labelTextSelected.replace('$$0$$', attr.selectedValue));
                        } else {
                            $label.text(labelTextSelect);
                            $variantContainer.find(`${selectors.variantLink}.${classes.selectedVariant}`).removeClass(classes.selectedVariant);
                        }
                    });
                }

                // JVP @TODO: Refactor in architechture sprint
                var $shippingMessage = response.container.find(selectors.shippingMessage);

                if (productData.readyToOrder) {
                    $shippingMessage.removeClass(CONST.classes.dNone).text(productData.shippingMessage);
                } else {
                    $shippingMessage.addClass(CONST.classes.dNone);
                }

                var $wishlistLink = $(selectors.addToWishlist);
                if ('isInWishlist' in productData && $wishlistLink.length > 0) {
                    if (productData.isInWishlist) {
                        $wishlistLink.addClass(CONST.classes.product.isInWishlist);
                    } else {
                        $wishlistLink.removeClass(CONST.classes.product.isInWishlist);
                    }
                }
            }
        });
    },
    updateAddToCart() {
        $(CONST.selectors.body).on(CONST.events.productUpdateAddToCart, function (e, response) {
            // The ATC button is no longer disabled by default.
            // When clicked upon a message should be shown to select a color/size
            // It is possible that some other elements should still be disabled.
        });
    },
    updateAvailability() {
        $(CONST.selectors.body).on(CONST.events.productAvailabilityUpdated, function (e, response) {
            $(selectors.availability, response.$productContainer)
                .data(CONST.attributes.readyToOrder, response.product.readyToOrder)
                .data(CONST.attributes.available, response.product.available);

            $(selectors.availabilityMessage, response.$productContainer)
                .empty().html(response.message);

            if ($(selectors.availabilityGlobal).length) {
                var allAvailable = $(selectors.availability).toArray()
                    .every(function (item) { return $(item).data(CONST.attributes.available); });

                var allReady = $(selectors.availability).toArray()
                    .every(function (item) { return $(item).data(CONST.attributes.readyToOrder); });

                $(selectors.availabilityGlobal)
                    .data(CONST.attributes.readyToOrder, allReady)
                    .data(CONST.attributes.available, allAvailable);

                $(`${selectors.availabilityGlobal} ${selectors.availabilityMessage}`).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart() {
        var $sizeChart;
        $(selectors.sizechartLink).on(CONST.events.click, function (e) {
            e.preventDefault();
            var url = $(this).attr(CONST.attributes.href);
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $sizeChart = $(selectors.modalBody);
                    $sizeChart.append(data.content);
                }
            });
        });
    },
    adjustChatIconPosition: adjustChatIconPosition
};
